const GOOGLE_SETUP_TOKEN_KEY = 'sellyt_google_setup_token';

/** Stores Google Response A setupToken for complete-signup (not a session Bearer). */
export const setGoogleSetupToken = (token: string): void => {
  try {
    sessionStorage.setItem(GOOGLE_SETUP_TOKEN_KEY, token.trim());
  } catch {
    // Ignore storage failures.
  }
};

export const getGoogleSetupToken = (): string | null => {
  try {
    const token = sessionStorage.getItem(GOOGLE_SETUP_TOKEN_KEY);
    return token?.trim() ? token.trim() : null;
  } catch {
    return null;
  }
};

export const clearGoogleSetupToken = (): void => {
  try {
    sessionStorage.removeItem(GOOGLE_SETUP_TOKEN_KEY);
  } catch {
    // Ignore storage failures.
  }
};
